import { render, staticRenderFns } from "./BidModal.vue?vue&type=template&id=4dcd16e2"
import script from "./BidModal.vue?vue&type=script&lang=js"
export * from "./BidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports